import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { isProductionGradeDeployment } from '@blaze-shared/platform-data-access';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { initializeSentry } from './sentry/sentry-intialization';

initializeSentry();

if (isProductionGradeDeployment(environment.deploymentTarget) && !environment.prodDebugOverride) {
  enableProdMode();
}

injectFontsCdn();

platformBrowserDynamic().bootstrapModule(AppModule);

function injectFontsCdn(): void {
  const link = document.createElement('link');
  link.href = `${environment.mediaCdnUrl}/fonts.css`;
  link.rel = 'stylesheet';
  globalThis.document.head.append(link);
}
